import React from 'react'
import { useFormContext } from 'react-hook-form'
import type { FashionOrderFormValues } from '../fashionOrder.schema'
import { useOrderItems } from '../contexts/OrderItemsContext'
import { Plus, RefreshCw, Trash2 } from 'lucide-react'
import { useInstallments } from '../Hooks/useInstallments'
import {
  Button, EmptyMessage, HeaderRow, InputText, InstallmentRow,
  InstallmentsTable, NumberCell, RemoveButton, SectionHeader, Separator,
  SummaryLine, Title,
} from '../style'
import { formatCentDigitsForInput, formatCurrency } from '../utils'

interface PaymentSectionProps {
  isEditing?: boolean
}

const PaymentSection: React.FC<PaymentSectionProps> = ({ isEditing = false }) => {
  const form = useFormContext<FashionOrderFormValues>()
  const { addedProducts } = useOrderItems()
  const installmentsApi = useInstallments({ form, addedProducts, isEditing })
  const {
    installments, installmentFields, handleUpdateInstallment, handleAddInstallment,
    handleRemoveInstallment, handleRefreshDueDates, sumInstallments, totalOrderAmount, hasMismatch,
  } = installmentsApi

  return (
    <>


          <SectionHeader>
            <Title style={{ fontSize: '14px' }}>
              Parcelas <span style={{ color: '#e53e3e', marginLeft: '4px' }}>*</span>
            </Title>
            <Button
              type="button"
              onClick={handleRefreshDueDates}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', fontSize: '12px' }}
            >
              <RefreshCw size={12} /> Atualizar parcelas
            </Button>
          </SectionHeader>

          {installments.length === 0 ? (
            <EmptyMessage style={{ margin: '16px 0' }}>
              Selecione uma condição de pagamento ou adicione parcelas manualmente.
            </EmptyMessage>
          ) : (
            <InstallmentsTable style={{ marginTop: '16px' }}>
              <HeaderRow>
                <span style={{ textAlign: 'center', fontSize: '12px' }}>Nº</span>
                <span style={{ fontSize: '12px' }}>Valor</span>
                <span style={{ fontSize: '12px' }}>Vencimento</span>
                <span style={{ fontSize: '12px' }}>Ações</span>
              </HeaderRow>

              {installmentFields.map((field, index) => {
                const inst = installments[index] ?? field
                return (
                <InstallmentRow key={field.rhfId}>
                  <NumberCell>{inst.numero}</NumberCell>
                  <div>
                    <InputText
                      className="inline-input"
                      type="text"
                      placeholder="R$ 0,00"
                      value={formatCentDigitsForInput(String(Math.round(Number(inst.valor || 0) * 100)))}
                      onChange={(e) => {
                        const digits = e.target.value.replace(/\D/g, '');
                        const centsVal = digits ? Number(digits) / 100 : 0;
                        handleUpdateInstallment(index, { valor: centsVal });
                      }}
                    />
                  </div>
                  <div>
                    <InputText
                      className="inline-date"
                      type="date"
                      max="9999-12-31"
                      value={inst.vencimento}
                      onChange={(e) => {
                        handleUpdateInstallment(index, { vencimento: e.target.value });
                      }}
                    />
                  </div>
                  <div>
                    <RemoveButton type="button" onClick={() => handleRemoveInstallment(index)}>
                      <Trash2 size={16} />
                    </RemoveButton>
                  </div>
                </InstallmentRow>
                )
              })}
            </InstallmentsTable>
          )}

          {hasMismatch && (
            <SummaryLine mismatch style={{ marginTop: '16px' }}>
              A soma das parcelas ({formatCurrency(sumInstallments)}) não corresponde ao total do pedido ({formatCurrency(totalOrderAmount)})
            </SummaryLine>
          )}

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', marginBottom: '16px' }}>
            <Button
              type="button"
              onClick={handleAddInstallment}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px' }}
            >
              <Plus size={14} /> Adicionar parcela
            </Button>
          </div>
    </>
  )
}

export default PaymentSection
